/** Injectable ID-token getter so api/tasks stays free of React imports. */

type IdTokenGetter = () => Promise<string | null>

let getter: IdTokenGetter | null = null

export function setIdTokenGetter(next: IdTokenGetter | null): void {
  getter = next
}

export async function getIdToken(): Promise<string | null> {
  return getter ? getter() : null
}
